/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadExpensesDetails(paymentDetails) {
  return await api
    .post(`/org/getexpense`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPrefixSettingsDetails(paymentDetails) {
  return await api
    .post(`/org/getsequenceno`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadFinancialYearDetails(paymentDetails) {
  return await api
    .post(`/masters/getfinacialyear`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createExpensesDetails(paymentDetails) {
  return await api
    .post(`/org/addexpense`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function updateExpensesDetails(paymentDetails) {
  return await api
    .put(`/org/updateexpense`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deleteExpensesDetails(paymentDetails) {
  return await api
    .post(`/org/deleteexpense`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadExpensesItemDetails(paymentDetails) {
  return await api
    .post(`/org/getexpenseitem`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadExpensesReportDetails(paymentDetails) {
  return await api
    .post(`/org/getexpensereport`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadCashBankReportDetails(paymentDetails) {
  return await api
    .post(`/org/getcashandbankreport`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadExpensesCategoriesDetails(paymentDetails) {
  return await api
    .post(`/org/getorgexpense`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadCashInHandDetails(paymentDetails) {
  return await api
    .post(`/org/getcashinhand`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadAccountTransactionDetails(paymentDetails) {
  return await api
    .post(`/org/getaccounttransactiondata`, paymentDetails)
    .then((response) => response.data && response.data.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadExpensesDetails,
  loadExpensesItemDetails,
  loadExpensesReportDetails,
  loadCashBankReportDetails,
  loadPrefixSettingsDetails,
  loadFinancialYearDetails,
  createExpensesDetails,
  loadRecordsMetaData,
  updateExpensesDetails,
  deleteExpensesDetails,
  loadExpensesCategoriesDetails,
  loadCashInHandDetails,
  loadAccountTransactionDetails,
};

export default remotes;
